import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TrashView = lazy(async () => {
  const m = await import("@/features/trash/components/trash-view");
  return { default: m.TrashView };
});

function TrashPageWrapper() {
  return (
    <Suspense fallback={null}>
      <TrashView />
    </Suspense>
  );
}

export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: TrashPageWrapper,
});
